import { withStyles } from '@material-ui/core/styles';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, Tab, Tabs, TextField, Theme, WithStyles } from "@material-ui/core";
import { mockTheme, toMap } from '../utils/utils';
import * as React from 'react';
import { ComponentClass } from 'react';
import { AppDispatch, IStore } from '../store';
import { connect } from 'react-redux';
import Grid from '@material-ui/core/Grid';

import { RaceActions } from '../store/race/race-actions';
import DriverLocation from '../components/DriverLocation';

import Typography from '@material-ui/core/Typography';
import LinearProgress from '@material-ui/core/LinearProgress';
import Paper from '@material-ui/core/Paper';
import { RaceState } from '../api/model';
import { IRaceStore } from '../store/race/race-reducer';
import { bindActionCreators } from 'redux';
import { NotificationActions } from '../store/notification/notification-actions';
import { DriverActions, IDriverStore } from '../store/driver';
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import StoreModel from '../store/StoreModel';
import Icon from '@material-ui/core/Icon';
// import RaceListComponent from '../components/race/RaceListComponent';
import { IConfigStore } from '../store/config';
import { IVisitStore } from 'src/store/visit/visit-reducer';
import { VisitActions } from 'src/store/visit/visit-actions';
import VisitsLocation from 'src/components/VisitsLocation';
// import VisitListComponent from 'src/components/visits/VisitListComponent';
import { RouteComponentProps } from 'react-router-dom';
// import { TableRacesComponent } from 'src/components/TableRacesComponent';
import { getApi } from 'src/api/ApiProvider';
// import RaceListComponent from 'src/components/race/RaceListComponent';
import { TableRacesComponent } from 'src/components/TableRacesComponent';
import { TableVisitsComponent } from 'src/components/TableVisitsComponent';



const styles = (theme: Theme) => ({
    panel: theme.mixins.gutters({
        paddingTop: 16,
        paddingBottom: 16,
        marginTop: theme.spacing.unit * 3,
    }),
    icon: {}
});


/**
 * This is a hack to has a object with the keys the same as the return of the #createStyles
 */
const classesType = styles(mockTheme);

const tipoComprobante = [
    { value: "FAC", label: "FAC" },
    { value: "RET", label: " RET" },
    { value: "NCR", label: " NCR" },
    { value: "REC", label: " REC" },
    { value: "AUT", label: " AUT" },
    { value: "FAE", label: " FAE" },
    { value: "CV", label: "CV" },
    { value: "ADEL", label: "ADEL" },
    { value: "EXT", label: "EXT" }
];

interface DashboardProps extends WithStyles<keyof typeof classesType>, RouteComponentProps<any> {

    actions: RaceActions;
    driverActions: DriverActions;
    visitActions: VisitActions;
    data: IRaceStore;
    driver: IDriverStore;
    config: IConfigStore;
    visit: IVisitStore;
}

interface DashboardState {
    openDialog: boolean;
    openDialogBranch: boolean;
    openDialogDriver: boolean;
    openDialogClient: boolean;
    tabValue: number;
    dataTemp: any;
    filterLoc: string;
    pageNum: number;
    pageSize: number;
    totalItems: number;
    data: any;
    filter: string;
    pageNumVisit: number;
    pageSizeVisit: number;
    filterVisit: string;
    dataVisit: any;
    totalItemsVisit: number;
    dateFrom: string;
    dateTo: string;
    dateFromVisit: string;
    dateToVisit: string;
    dataDrivers: any;
}

class ReportRacesPage extends React.Component<DashboardProps, DashboardState> {



    constructor(props: DashboardProps) {
        super(props);

        this.state = {
            openDialog: false,
            openDialogBranch: false,
            openDialogDriver: false,
            openDialogClient: false,
            tabValue: 0,
            dataTemp: {},
            filterLoc: '',
            pageNum: 0,
            pageSize: 5,
            totalItems: 0,
            data: null,
            dataVisit: null,
            totalItemsVisit: 0,
            filter: '',
            pageNumVisit: 0,
            pageSizeVisit: 5,
            filterVisit: '',
            dateFrom: '',
            dateTo: '',
            dateFromVisit: '',
            dateToVisit: '',
            dataDrivers:null
        };


        this.loadByState = this.loadByState.bind(this);
    }
    // Modificar documentos
    setDialog = (open: boolean, data?: any) => {
        this.setState({
            openDialog: open,
            dataTemp: data
        }, () => {
            console.log(this.state.dataTemp)
        });
    }
    setDialogBranch = (open: boolean, data?: any) => {
        this.setState({
            openDialogBranch: open,
            dataTemp: data
        }, () => {
            console.log(this.state.dataTemp)
        });
    }
    setDialogDriver = (open: boolean, data?: any) => {
        this.setState({
            openDialogBranch: open,
            dataTemp: data
        }, () => {
            console.log(this.state.dataTemp)
        });
    }
    setDialogClient = (open: boolean, data?: any) => {
        this.setState({
            openDialogBranch: open,
            dataTemp: data
        }, () => {
            console.log(this.state.dataTemp)
        });
    }
    handleSelectChangeComprobanteOnRow = (event: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({
            dataTemp: {
                ...this.state.dataTemp,
                tipoComprobante: event.target.value
            }
        }, () => {
            console.log(this.state.dataTemp)
        });
    };
    setNroComprobante(e: React.ChangeEvent<HTMLInputElement>) {
        this.setState({
            dataTemp: {
                ...this.state.dataTemp,
                nroComprobante: e.target.value
            }
        }, () => {
            console.log(this.state.dataTemp)
        });
    }
    guardarDocumento() {
        this.setDialog(false);
        const data = {
            id: this.state.dataTemp.id,
            tipoComprobante: this.state.dataTemp.tipoComprobante,
            nroComprobante: this.state.dataTemp.nroComprobante
        }
        console.log(data, '123', this.props, data)
        this.props.actions.update(this.state.dataTemp, this.props.history);
    }
    // FIN Modificar documentos

    componentDidMount() {
        this.props.actions.fetchAll();
        this.props.driverActions.fetchLocations();
        this.getRaces(0, 5, '');

    }

    loadByState(state: RaceState) {
        this.props.actions.fetchByState(state);

    }
    getRaces(pageNum?: number, pageSize?: number, search?: string, from?: string, to?: string) {
        console.log(pageNum, pageSize, search, from, to)
        getApi().race().all(pageNum, pageSize, search, from, to).then((data: any) => {
            console.log(data)
            this.setState({
                data: data.content,
                totalItems: data.totalElements
            });
        })

    }
    getVisits(pageNum?: number, pageSize?: number, search?: string, from?: string, to?: string) {
        getApi().visit().all(pageNum, pageSize, search, from, to).then((data: any) => {
            console.log(data, '179')
            this.setState({
                dataVisit: data.content,
                totalItemsVisit: data.totalElements
            });
        })

    }

    setFilter = (filter: string) => {
        this.setState({ filter }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSize, this.state.filter, this.state.dateFrom, this.state.dateTo);
        });
    };

    setPageNum = (pageNum: number) => {
        this.setState({ pageNum }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSize, this.state.filter, this.state.dateFrom, this.state.dateTo);
        });
    };

    setPageSize = (pageSize: number) => {
        this.setState({ pageSize }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSize, this.state.filter, this.state.dateFrom, this.state.dateTo);
        });
    };

    setDateFromChange = (dateFrom: string) => {
        this.setState({ dateFrom }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSize, this.state.filter, this.state.dateFrom, this.state.dateTo);
        });
    };

    setDateToChange = (dateTo: string) => {
        this.setState({ dateTo }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSize, this.state.filter, this.state.dateFrom, this.state.dateTo);
        });
    };
    setDateFromChangeVisit = (dateFromVisit: string) => {
        this.setState({ dateFromVisit }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    };

    setDateToChangeVisit = (dateToVisit: string) => {
        this.setState({ dateToVisit }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    };

    setFilterVisit = (filterVisit: string) => {
        this.setState({ filterVisit }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    };

    setPageNumVisit = (pageNumVisit: number) => {
        this.setState({ pageNumVisit }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    };

    setPageSizeVisit = (pageSizeVisit: number) => {
        this.setState({ pageSizeVisit }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    };
    cleanFiltersRaces = () => {
        this.setState({ filter: '', dateFrom: '', dateTo: '' }, () => {
            this.getRaces(this.state.pageNum, this.state.pageSize, this.state.filter, this.state.dateFrom, this.state.dateTo);
        });
    }
    cleanFiltersVisits = () => {
        this.setState({ filterVisit: '', dateFromVisit: '', dateToVisit: '' }, () => {
            this.getVisits(this.state.pageNumVisit, this.state.pageSizeVisit, this.state.filterVisit, this.state.dateFromVisit, this.state.dateToVisit);
        });
    }

    renderRaceList() {
        if (StoreModel.isLoading(this.props.data.all)) {
            return (
                <LinearProgress />
            )
        }
        if (StoreModel.isError(this.props.data.all)) {
            return (
                <Typography color="error">
                    Error: {this.props.data.resume.error}
                </Typography>
            )
        }

        return (
            <Grid>
                <TableRacesComponent
                    data={this.state.data}
                    dataDrivers={this.state.dataDrivers}
                    dataBranches={[]}
                    dataBranchesDestiny={[]}
                    totalItems={this.state.totalItems}
                    pageNum={this.state.pageNum}
                    pageSize={this.state.pageSize}
                    filter={this.state.filter}
                    onFilterChange={this.setFilter}
                    onPageNumChange={this.setPageNum}
                    onPageSizeChange={this.setPageSize}
                    onDateFromChange={this.setDateFromChange}
                    onDateToChange={this.setDateToChange}
                    handleClearFilters={this.cleanFiltersRaces}
                    dateFrom={this.state.dateFrom}
                    dateTo={this.state.dateTo}
                    setDialog={this.setDialog}
                    setDialogBranch={this.setDialogBranch}
                    setDialogDriver={this.setDialogDriver}
                    setDialogClient={this.setDialogClient}
                    setDialogChangeState={() => console.log('change state')}
                    onHandleTypeChange={() => console.log('change type')}
                    selectedType=''
                    driverId={0}
                    onHandleDriverChange={() => console.log('change driver')}
                    onHandleStateChange={()=>console.log('change state')}
                    selectedState=''
                    generalSearch=''
                    onHandleBranchChange={()=>console.log('change branch')}
                    onHandleBranchDestinyChange={()=>console.log('change branch destiny')}
                    branchId={0}
                    branchDestinyId={0}
                    handleGeneralSearch={()=>console.log('search')}
                    filtrosOn={false}
                />
                <Dialog open={this.state.openDialog} onClose={() => this.setDialog(false)}>
                    <DialogTitle>{"Documentos del Reparto"}</DialogTitle>
                    <DialogContent>
                        <Typography gutterBottom>
                            Tipo de documento
                        </Typography>
                        <Select value={this.state.dataTemp && this.state.dataTemp.tipoComprobante ? this.state.dataTemp.tipoComprobante : ''} onChange={(event) => this.handleSelectChangeComprobanteOnRow(event)}>
                            {tipoComprobante.map((option, index) => (
                                <MenuItem key={index} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>

                        <TextField
                            label="Nro documento (opcional)"
                            type="number"
                            onChange={(e) => this.setNroComprobante(e)}
                            value={this.state.dataTemp && this.state.dataTemp.nroComprobante ? this.state.dataTemp.nroComprobante : ''}
                            style={{
                                width: '90%'
                            }}
                            margin="normal"
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => this.guardarDocumento()} color="primary">
                            Guardar
                        </Button>
                        <Button onClick={() => this.setDialog(false)} color="secondary">
                            Cerrar
                        </Button>
                    </DialogActions>
                </Dialog>
            </Grid>
        )
    }
    renderVisitList() {
        if (StoreModel.isLoading(this.props.visit.all)) {
            return (
                <LinearProgress />
            )
        }
        if (StoreModel.isError(this.props.visit.all)) {
            return (
                <Typography color="error">
                    Error: {this.props.visit.resume.error}
                </Typography>
            )
        }

        // return <VisitListComponent data={this.props.visit.all.data} />
        return <TableVisitsComponent
            data={this.state.dataVisit}
            totalItems={this.state.totalItemsVisit}
            pageNum={this.state.pageNumVisit}
            pageSize={this.state.pageSizeVisit}
            filter={this.state.filterVisit}
            onFilterChange={this.setFilterVisit}
            onPageNumChange={this.setPageNumVisit}
            onPageSizeChange={this.setPageSizeVisit}
            onDateFromChangeVisit={this.setDateFromChangeVisit}
            onDateToChangeVisit={this.setDateToChangeVisit}
            handleClearFilters={this.cleanFiltersVisits}
            dateFromVisit={this.state.dateFromVisit}
            dateToVisit={this.state.dateToVisit}
        />
    }
    handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        this.setState({ tabValue: newValue });
        if (newValue === 1) {
            // this.props.visitActions.fetchAll();
            this.getVisits(0, 5, '');
        }
    };

    render() {

        return (
            <Grid container spacing={8}>

                <Grid item sm={12} md={12} lg={12}>
                    <Tabs value={this.state.tabValue} onChange={this.handleTabChange}>
                        <Tab label="Repartos" />
                        <Tab label="Visitas" />
                    </Tabs>
                    {this.state.tabValue === 0 && (
                        <>
                            <Paper className={this.props.classes.panel} elevation={5}>
                                <Typography variant="headline" component="h3">
                                    Repartos
                                    {/* <Icon className={this.props.classes.icon} color="primary"
                                        onClick={this.getRaces(1,5,'')}>refresh
                                    </Icon> */}
                                </Typography>

                                {this.renderRaceList()}
                            </Paper>

                            <Grid item sm={12} md={12} lg={12}>
                                <Paper className={this.props.classes.panel} elevation={5}>
                                    <BlockUi tag="div" blocking={StoreModel.isLoading(this.props.driver.locations)}>
                                        <Typography variant="headline" component="h3">Ubicación de motistas
                                            <Icon className={this.props.classes.icon} color="primary"
                                                onClick={this.props.driverActions.fetchLocations}>
                                                refresh
                                            </Icon>
                                        </Typography>
                                        <DriverLocation data={this.props.driver.locations.data} config={this.props.config.data} />
                                    </BlockUi>
                                </Paper>
                            </Grid>
                        </>
                    )}
                    {
                        this.state.tabValue === 1 && (
                            <>
                                <Paper className={this.props.classes.panel} elevation={5}>

                                    <Typography variant="headline" component="h3">
                                        Visitas
                                        {/* <Icon className={this.props.classes.icon} color="primary"
                                            onClick={this.props.actions.fetchAll}>refresh
                                        </Icon> */}
                                    </Typography>


                                    {this.renderVisitList()}

                                </Paper>

                                <Paper className={this.props.classes.panel} elevation={5}>

                                    <Grid item sm={12} md={12} lg={12}>
                                        <Paper className={this.props.classes.panel} elevation={5}>
                                            <BlockUi tag="div" blocking={StoreModel.isLoading(this.props.visit.all)}>
                                                <Typography variant="headline" component="h3">Ubicación de visitas
                                                    <Icon className={this.props.classes.icon} color="primary"
                                                        onClick={this.props.visitActions.fetchAll}>
                                                        refresh
                                                    </Icon>
                                                </Typography>
                                                <VisitsLocation
                                                    data={this.props.visit.all.data}
                                                    config={this.props.config.data} />
                                            </BlockUi>
                                        </Paper>
                                    </Grid>
                                </Paper>
                            </>
                        )
                    }
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state: IStore, ownProps: DashboardProps): DashboardProps => ({
    ...ownProps,
    data: state.race,
    driver: state.driver,
    visit: state.visit,
    config: state.config
});


const styled = withStyles(styles as any)(ReportRacesPage);
const connected = connect(mapStateToProps, (dispatch: AppDispatch) => {
    return {
        actions: bindActionCreators(toMap(RaceActions), dispatch),
        driverActions: bindActionCreators(toMap(DriverActions), dispatch),
        visitActions: bindActionCreators(toMap(VisitActions), dispatch),
        notification: bindActionCreators(toMap(NotificationActions), dispatch)
    }
})(styled);

export default connected as ComponentClass<Partial<DashboardProps>>;



// WEBPACK FOOTER //
// ./src/pages/ReportRacesPage.tsx